import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import ParentRegisterForm from "../../forms/parentRegisterForm";
import CustomButton from "../../../../components/lib/customButton";
import { formatCPF } from "../../../../utils/DocumentUtils";
import Spinner from "../../../../components/lib/spinner";
import Stepper from "../../../../components/lib/stepperHeader";

const STEP = {
    PARENT_CREATE: 0,
    SUMMARY: 1,
};

const steps = [
    { key: STEP.PARENT_CREATE, label: "Responsável" },
    { key: STEP.SUMMARY, label: "Resumo" },
];


const ParentRegisterStepper = ({ onFinish, onCancel, onDirty, isSubmitting }) => {
    const [step, setStep] = useState(STEP.PARENT_CREATE);
    const [parentDraft, setParentDraft] = useState(null);

    const submitActiveForm = () => {
        document.querySelector("form[data-step-form]")?.requestSubmit();
    };

    const goBack = () => {
        if (step === STEP.PARENT_CREATE) return onCancel();
        setStep(step - 1);
    };

    return (
        <div className="flex flex-col gap-6">
            <Stepper
                steps={steps}
                currentStep={step}
            />

            {/* CONTENT */}
            <div className="min-h-[360px]">
                <AnimatePresence mode="wait">
                    <motion.div key={step} initial={{ opacity: 0, x: 20 }} animate={{ opacity: 1, x: 0 }} exit={{ opacity: 0, x: -20 }} transition={{ duration: 0.2 }}>

                        {/* STEP 1 */}
                        {step === STEP.PARENT_CREATE && (
                            <ParentRegisterForm
                                onDirty={onDirty}
                                onSubmit={(data) => {
                                    setParentDraft(data);
                                    setStep(STEP.SUMMARY);
                                }}
                            />
                        )}

                        {/* STEP 2 */}
                        {step === STEP.SUMMARY && (
                            <div className="space-y-4">
                                <h3 className="font-semibold">Resumo</h3>

                                <div className="border rounded p-4 text-sm text-start space-y-1">
                                    <div>
                                        <p className="font-medium">{parentDraft.name}</p>
                                        <p className="text-xs text-gray-500">{parentDraft.email}</p>
                                        <p className="text-xs text-gray-500">{formatCPF(parentDraft.cpf)}</p>
                                        <p className="text-xs text-gray-500">{parentDraft.phone_number}</p>
                                        <p className="text-xs text-gray-500">{parentDraft.address}</p>
                                    </div>
                                </div>
                            </div>
                        )}
                    </motion.div>
                </AnimatePresence>
            </div>

            {/* FOOTER */}
            <div className="flex justify-between">
                <CustomButton
                    buttonType={step === STEP.PARENT_CREATE ? "cancel" : "confirmLater"}
                    text={step === STEP.PARENT_CREATE ? "Cancelar" : "Voltar"}
                    showIcon={false}
                    onClick={goBack}
                />


                {step === STEP.PARENT_CREATE && (
                    <CustomButton buttonType="confirm" text="Avançar" showIcon={false}
                        onClick={submitActiveForm} />
                )}

                {step === STEP.SUMMARY && (
                    <CustomButton
                        buttonType="confirm"
                        text={
                            isSubmitting ? (
                                <>
                                    <span className="ml-2">Processando</span>
                                    <Spinner />
                                </>
                            ) : (
                                "Concluir"
                            )
                        }
                        showIcon={false}
                        disabled={isSubmitting}
                        onClick={() =>
                            onFinish({
                                parent: parentDraft,
                            })
                        }
                    />
                )}
            </div>
        </div>
    );
};

export default ParentRegisterStepper;
